import React from 'react'
import { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { useAppIntl } from 'src/i18n'

export const StickyContentNav = ({ links }) => {
  const intl = useAppIntl()
  const [activeIndex, setActiveIndex] = useState(0)
  const [isClicked, setIsClicked] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (!isClicked && links) {
        const scrollPosition = window.scrollY
        const windowHeight = window.innerHeight
        const documentHeight = document.documentElement.scrollHeight

        if (scrollPosition + windowHeight >= documentHeight) {
          setActiveIndex(links.length - 1) // Markera den sista sektionen
        } else {
          links.forEach((item, index) => {
            const targetElement = document.getElementById(item.targetId)
            if (targetElement) {
              const { offsetTop } = targetElement
              if (scrollPosition >= offsetTop - 200) {
                setActiveIndex(index)
              }
            }
          })
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [links, isClicked])

  const handleClick = (event, targetId, index) => {
    event.preventDefault()
    setIsClicked(true)
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      setActiveIndex(index)
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }

    setTimeout(() => {
      setIsClicked(false)
    }, 700)
  }
  return (
    <div className={styles.sidebar}>
      <h2 className={styles.sidebar__title}>
        {intl.t('review.sidebar.title')}
      </h2>
      <div className={styles.sidebar__ul}>
        {links?.map((item, index) => (
          <a
            key={item.title}
            href={`#${item.targetId}`}
            className={`${styles.sidebar__link} ${
              activeIndex === index ? styles.sidebar__active : ''
            }`}
            onClick={event => handleClick(event, item.targetId, index)}
          >
            <p
              className={`${styles.sidebar__p} ${
                activeIndex === index ? styles.sidebar__activep : ''
              }`}
            >
              {item.title}
            </p>
          </a>
        ))}
      </div>
    </div>
  )
}
